import React from 'react';

import { getMonth, getYear } from 'date-fns';
import { range } from 'lodash';

import ChevronLeftIcon from 'Assets/icons/chevron-left.svg';
import ChevronRightIcon from 'Assets/icons/chevron-right.svg';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const CustomHeader = ({ min, max, date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
    const years = min && max ? range(getYear(new Date(min)), getYear(new Date(max)) + 1, 1) : range(getYear(new Date()) - 10, getYear(new Date()) + 20, 1);

    return (
        <div className="tw-m-2.5 tw-flex tw-items-center tw-gap-x-2">
            <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                <ChevronLeftIcon className="tw-h-3 tw-w-3" />
            </button>
            <div className="tw-flex tw-items-center">
                <select className="select select-input !tw-rounded-r-none" value={getYear(date)} onChange={({ target: { value } }) => changeYear(value)}>
                    {years.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
                <select
                    className="select select-input !tw-rounded-l-none !tw-border-l-0"
                    value={MONTHS[getMonth(date)]}
                    onChange={({ target: { value } }) => changeMonth(MONTHS.indexOf(value))}
                >
                    {MONTHS.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>
            <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                <ChevronRightIcon className="tw-h-3 tw-w-3" />
            </button>
        </div>
    );
};

export default CustomHeader;
